import { BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import styled, { css } from 'styled-components';

const normalMessageStyles = css`
    display: inline-block;
    border-radius: 16px;
    padding: 4px 8px;
    margin: 0 4px 0;

    @media (min-width: 1000px) {
        border-radius: 24px;
        padding: 8px 16px;
        margin: 0 8px 0;
    }
`;

export const StyledRed = styled(BodySecondary)`
    ${normalMessageStyles}
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.red100};
`;

export const StyledGrey = styled(BodySecondary)`
    ${normalMessageStyles}
    background-color: ${({ theme }) => theme.colors.grey500};
    border: 1px solid ${({ theme }) => theme.colors.grey400};
`;

export const StyledGreyDark = styled(BodySecondary)`
    ${normalMessageStyles}
    background-color: ${({ theme }) => theme.colors.grey500};
    border: 1px solid ${({ theme }) => theme.colors.grey400};
`;

export const StyledGreen = styled(BodySecondary)`
    ${normalMessageStyles}
    background-color: ${({ theme }) => theme.colors.greenLight};
    border: 1px solid ${({ theme }) => theme.colors.teal};
`;

export const StyledGreenFull = styled(BodySecondary)`
    display: block;
    padding: 16px;
    background-color: ${({ theme }) => theme.colors.greenLight};
`;

export const StyledBlue = styled(BodySecondary)`
    ${normalMessageStyles}
    background-color: ${({ theme }) => theme.colors.blueLight};
    border: 1px solid ${({ theme }) => theme.colors.blue100};
`;

export const StyledColumnMessage = styled.div`
    padding: 8px 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    margin-bottom: 0;
`;
